import { globalObj } from "./global";
import appSDK from "./appSDK";

export const login = () => {
    const fullPath = window.location.pathname + window.location.search
    localStorage.prePath = fullPath
    const envType = globalObj.getEnvType()
    if (envType.startsWith('FLUTTER')) {
        appSDK.loginOut({
            isPassive: true,
        })
    }
}